import styled from 'styled-components'

/** Corpo do popover: lista rolável de análises + rodapé fixo com o resumo. */
export const ContainerSelecaoEmMassa = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    gap: 10px;

    .selecao__massa__titulo {
        font-size: 13px;
        font-weight: 600;
        color: var(--text-color);
        margin: 0 0 10px;
        padding: 0;
    }

    .selecao__massa__lista {
        display: flex;
        flex-direction: column;
        gap: 12px;
        overflow-y: auto;
        padding-bottom: 15px;
        margin-top: -15px;
    }

    .selecao__massa__grupo {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .selecao__massa__profundidade {
        font-size: 12px;
        font-weight: 500;
        color: var(--text-color-light);
        margin: 0;
        padding: 0;
    }

    /* A linha inteira é clicável, por isso o padding/hover ficam nela e não no checkbox. */
    .selecao__massa__item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 5px 6px;
        padding-left: 0px;
        border-radius: 6px;
        cursor: pointer;
        user-select: none;
        margin-top: -8px;
        transition: background-color 0.15s;

        &:hover {
            background-color: var(--hover-color, rgba(0, 0, 0, 0.04));
        }

        &:focus-visible {
            outline: 2px solid var(--primary-color);
            outline-offset: -2px;
        }
    }

    /* O checkbox é só indicador visual: o clique é da linha. */
    .selecao__massa__checkbox {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        pointer-events: none;
    }

    .selecao__massa__cor {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        flex-shrink: 0;
    }

    .selecao__massa__nome {
        font-size: 13px;
        font-weight: 600;
        color: var(--text-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Nunca encolhe: a quantidade de pontos é o dado que orienta a decisão. */
    .selecao__massa__qtd {
        font-size: 13px;
        color: var(--text-color-light);
        white-space: nowrap;
        flex-shrink: 0;
    }
`

/** Rodapé com o total descontado, o grid amostral e o botão de confirmar. */
export const FooterSelecaoEmMassa = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    flex-shrink: 0;
    height: 45px;

    .selecao__massa__resumo {
        display: flex;
        flex-direction: column;
        line-height: 1.35;

        strong {
            font-size: 13px;
            font-weight: 700;
            color: var(--text-color);
        }

        span {
            font-size: 12px;
            color: var(--text-color-light);
        }
    }
`

/**
 * Invólucro usado somente em tela cheia.
 *
 * O ModalPopOver renderiza num portal fora do elemento em fullscreen, e o navegador
 * não exibe nada fora dele — por isso, em fullscreen, o mesmo conteúdo é montado
 * localmente com esta casca visual.
 */
export const PopOverLocal = styled.div`
    position: absolute;
    z-index: 1001;
    /* Sobrepõe o botão: ancora no topo da linha de botões e cresce para baixo por cima dela. */
    top: 0;
    left: 0;
    width: 100%;
    /**
     * Limite em px, não em vh: a sidebar agora tem altura própria e rola, então uma
     * medida da viewport deixaria o popover passar da borda e ser cortado pelo
     * overflow do container. O corpo interno rola quando a lista é maior que isto.
     */
    max-height: 400px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 10px;
    box-shadow: rgba(153, 153, 153, 0.5) 0px 0px 15px;
    overflow: hidden;

    .popover__local__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 8px 12px;
        font-size: 13px;
        font-weight: 700;
        color: var(--text-color);
        border-bottom: thin solid var(--border-color);
        flex-shrink: 0;
    }

    .popover__local__fechar {
        width: 28px;
        height: 28px;
        border: none;
        background: transparent;
        border-radius: 8px;
        color: #ff595b;
        cursor: pointer;

        :hover {
            background: #ff595b;
            color: #fff;
        }
    }

    .popover__local__body {
        box-sizing: border-box;
        padding: 12px;
        min-height: 0;
        overflow-y: auto;
    }
`

/** Ancora o popover local ao botão dentro da sidebar em fullscreen. */
export const AncoraSelecaoEmMassa = styled.div`
    position: relative;
    width: 100%;
`
